import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../../shared/models/component-messages/mapaAN/step1';
import { FormUtilsService } from '../../../../../shared/services/form-utils.service';
import { LogService } from '../../../../../shared/services/log.service';
import { ObjectToJsonStepperCreatorService } from '../../../../../shared/services/object-to-json-stepper-creator.service';
import { AvisInitialTypeLight } from '../../models/AvisInitialTypeLight';

@Component({
  selector: 'app-step1',
  templateUrl: './step1.component.html'
})
export class Step1Component implements OnInit {

  private LOG: LogService = new LogService(Step1Component);

	@Input() avisInitial: AvisInitialTypeLight;
	@Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	
  @Input() linkForRouter: string;

	@Input() uid = '';


  constructor(
    public objectToJsonStepperCreatorService: ObjectToJsonStepperCreatorService,
		private formUtilsService: FormUtilsService) { }

  ngOnInit(): void {
  }

  public step1 = new Step1();

  getUid(){
    return this.uid;
  }
}
